import type { CustomerOrder } from '../../customerOrdersApi'
import type { CustomerProfile } from '../../types'
import { EmptyStateBlock } from '../customer-area'
import { LocationIcon, resolveShippingLines, type CustomerOrderDetailLabels } from './orderDetailShared'

type CustomerOrderShippingSummarySectionProps = {
  orderDetail: CustomerOrder
  profile: CustomerProfile
  labels: CustomerOrderDetailLabels
}

export const CustomerOrderShippingSummarySection = ({
  orderDetail,
  profile,
  labels,
}: CustomerOrderShippingSummarySectionProps) => {
  const shipping = resolveShippingLines(orderDetail, profile)

  return (
    <section className="ca-card-shell ca-theme-transition rounded-xl px-5 py-5">
      <h3 className="text-sm font-semibold text-(--color-text-primary)">{labels.shippingTitle}</h3>
      {shipping.lines.length > 0 ? (
        <address className="mt-2 space-y-0.5 text-sm text-(--color-text-secondary) not-italic">
          {shipping.lines.map((line, index) => (
            <p key={`${line}-${index}`}>{line}</p>
          ))}
          {profile.phone ? (
            <p className="pt-1 text-xs text-(--color-text-muted)">{profile.phone}</p>
          ) : null}
        </address>
      ) : (
        <div className="mt-2">
          <EmptyStateBlock
            icon={<LocationIcon className="h-4 w-4" />}
            title={labels.shippingMissingTitle}
            description={labels.shippingMissing}
            className="px-3 py-4 text-left"
          />
        </div>
      )}
    </section>
  )
}
